$mol_icon_menu_down $mol_icon path \M7,10L12,15L17,10H7Z
